/**
 * Apply portal branding fetch (Phase H0 hotfix mirror).
 *
 * The IA admin previously customised branding and only the apply
 * portal honoured it; the apply portal already had access to the
 * tenant slug from the host name but never drove a CSS-var update.
 * This brings parity: a tenant who customises their colour + logo
 * sees both the IA portal AND the apply portal repaint in their
 * brand.
 */

import { useQuery } from "@tanstack/react-query";
import { publicApi } from "@/lib/api";
import type { BrandingPublic } from "./types";

const PUBLIC_BASE = (slug: string) => `/tenants/${slug}/branding`;

export function useTenantBranding(slug: string | null | undefined) {
  return useQuery<BrandingPublic>({
    queryKey: ["public-branding", slug],
    queryFn: async () => {
      const res = await publicApi.get<BrandingPublic>(PUBLIC_BASE(slug as string));
      return res.data;
    },
    enabled: Boolean(slug),
    staleTime: 5 * 60 * 1000,
  });
}
